import { Module } from 'app/library/module/models/module.model';
import { ModuleUser } from 'app/library/module-user/models/module-user.model';
import { ModuleFeatureContentTabStatus } from '../enums/module-feature-content-tab-status.enum';

export function normalizeContentTabStatus(status: string): ModuleFeatureContentTabStatus {
    switch (status) {
        case ModuleFeatureContentTabStatus.Hidden:
            return ModuleFeatureContentTabStatus.Hidden;
        case ModuleFeatureContentTabStatus.AdminsOnly:
            return ModuleFeatureContentTabStatus.AdminsOnly;
        case ModuleFeatureContentTabStatus.Active:
            return ModuleFeatureContentTabStatus.Active;
        case 'inactive':
            return ModuleFeatureContentTabStatus.Hidden;
        default:
            return ModuleFeatureContentTabStatus.Active;
    }
}

export function isContentTabModuleStaff(moduleUser: ModuleUser | null | undefined): boolean {
    return !!(moduleUser?.isManager || moduleUser?.isResponsible);
}

export function isContentTabHiddenForParticipants(contentTabStatus: string, module: Module, moduleUser: ModuleUser | null | undefined): boolean {
    const status = normalizeContentTabStatus(contentTabStatus);

    if (status === ModuleFeatureContentTabStatus.Hidden) {
        return true;
    }

    if (status === ModuleFeatureContentTabStatus.AdminsOnly) {
        return !isContentTabModuleStaff(moduleUser);
    }

    return false;
}

export function isContentTabVisibleForParticipantView(
    contentTabStatus: string,
    module: Module,
    moduleUser: ModuleUser | null | undefined
): boolean {
    return !isContentTabHiddenForParticipants(contentTabStatus, module, moduleUser);
}

export function isContentTabVisibleForAdminEdit(contentTabStatus: string, module: Module): boolean {
    return normalizeContentTabStatus(contentTabStatus) !== ModuleFeatureContentTabStatus.Hidden;
}

export function isContentTabHiddenFromEditNavigation(contentTabStatus: string, module: Module): boolean {
    return !isContentTabVisibleForAdminEdit(contentTabStatus, module);
}

export function getContentTabVisibilityDescriptionKey(status: ModuleFeatureContentTabStatus): string {
    switch (status) {
        case ModuleFeatureContentTabStatus.Hidden:
            return 'PAGE.MODULE_FORM.TAB.SETTINGS.CONTENT.VISIBILITY.HIDDEN_DESCRIPTION';
        case ModuleFeatureContentTabStatus.AdminsOnly:
            return 'PAGE.MODULE_FORM.TAB.SETTINGS.CONTENT.VISIBILITY.ADMINS_ONLY_DESCRIPTION';
        case ModuleFeatureContentTabStatus.Active:
            return 'PAGE.MODULE_FORM.TAB.SETTINGS.CONTENT.VISIBILITY.EVERYONE_DESCRIPTION';
    }
}
